import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Format Align Left"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-format-align-left',
    templateUrl: './icon-format-align-left.component.html',
    styleUrls: ['./icon-format-align-left.component.scss'],
    standalone: false
})
export class IconFormatAlignLeftComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
